module.exports = __webpack_public_path__ + "static/img/Quicksand-Medium.afb859d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Medium.svg
// module id = McaL
// module chunks = 1